export default "__VITE_ASSET__75Tdz3VY__"